import { configureStore } from '@reduxjs/toolkit';
import userPermissionReducer from './slices/userPermissionSlice';

const store = configureStore({
  reducer: {
    userPermission: userPermissionReducer,
  },
});

export default store;
